import './H3.scss';

import React from 'react';
import PropTypes from 'prop-types';

export default class H3 extends React.Component {
    static propTypes = {
        className: PropTypes.string
    };

    render() {
        let { className, ...otherProps } = this.props;
        return (
            <h3 {...otherProps}
                className={`c-h3 ${className || ''}`}>
                {this.props.children}
            </h3>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/H3/index.js